import BaseResource from './index'

export default class ReservationCheckoutResource extends BaseResource {
    static endpoint = '/reservations/checkouts'

    static async quote(reservations, voucherId = null, packageDealId = null) {
        const reservObject = reservations.map((reserv) => {
            return {
                slot: reserv.attributes.slot,
                calendar: reserv.attributes.calendar
            }
        })

        const body = { reservations: reservObject, voucher: voucherId }
        if (packageDealId) {
            body.package_deal = packageDealId
        }

        const result = await this.wrap('/quote').post(body)
        const checkoutData = result.data
        checkoutData.commit = async () => {
            const response = await this.wrap(`/${checkoutData.checkout_id}/process`).post()

            if (response.status == 200) {
                return response.data
            }
        }
    
        return checkoutData
    }

    async createPaymentLink() {
        const response = await this.wrap('/payment_link').post()
        if (response.status == 200) {
            return response.data.url
        }

        return false
    }
}